import type { LineChartProps } from "@mui/x-charts/LineChart";

import { PLOT_PADDING_Y, Y_AXIS_WIDTH } from "~/feature/chart/constants";

import type { IChartLine } from "./buildChartLines";
import {
  CHART_UNAVAILABLE_TEXT,
  LINE_CURVE,
  Y_AXIS_MAX,
  Y_AXIS_MIN,
  Y_AXIS_TICKS,
} from "./constants";
import { noDataOverlaySx } from "./LinearChart.styles";
import type { IYAxisRange } from "./yAxisRange";

type LineSeries = NonNullable<LineChartProps["series"]>[number];

export const X_AXIS_ID = "timeline";

export const AXIS_HIGHLIGHT: LineChartProps["axisHighlight"] = { x: "line" };

export const getXAxis = (timeline: number[]): LineChartProps["xAxis"] => [
  {
    id: X_AXIS_ID,
    data: timeline.map((timestamp) => new Date(timestamp)),
    scaleType: "point",
    height: 0,
    disableLine: true,
    disableTicks: true,
  },
];

export const toLineSeries = ({ key, color, data }: IChartLine): LineSeries => ({
  id: key,
  data,
  color,
  curve: LINE_CURVE,
  showMark: false,
  shape: "circle",
  connectNulls: true,
});

export const getYAxis = ({
  min,
  max,
}: IYAxisRange): LineChartProps["yAxis"] => [
  {
    min,
    max,
    ...(min === Y_AXIS_MIN && max === Y_AXIS_MAX
      ? { tickInterval: Y_AXIS_TICKS }
      : {}),
    width: Y_AXIS_WIDTH,
    disableLine: true,
    disableTicks: true,
    valueFormatter: (value: number) => `${value}%`,
  },
];

export const CHART_MARGIN: LineChartProps["margin"] = {
  top: PLOT_PADDING_Y,
  right: 0,
  bottom: PLOT_PADDING_Y,
  left: 0,
};

export const SLOT_PROPS: LineChartProps["slotProps"] = {
  noDataOverlay: { sx: noDataOverlaySx },
  tooltip: { trigger: "none" },
};

export const UNAVAILABLE_LOCALE_TEXT: LineChartProps["localeText"] = {
  noData: CHART_UNAVAILABLE_TEXT,
};
